/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/default-props-match-prop-types */
import React, { PropTypes, Component } from 'react'
import classnames from 'classnames'
import constants from 'constants'
import Suggestions from './components/Suggestions'
import styles from './SearchFilterInput.scss'

class SearchFilterInput extends Component {
  static propTypes = {
    allowDeleteFromEmptyInput: PropTypes.bool,
    autocomplete: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    autofocus: PropTypes.bool,
    className: PropTypes.string,
    delimeters: PropTypes.array,
    disabled: PropTypes.bool,
    focus: PropTypes.bool,
    handleSubmit: PropTypes.func,
    id: PropTypes.string,
    inline: PropTypes.bool,
    labelField: PropTypes.string,
    minQueryLength: PropTypes.number,
    mustMatch: PropTypes.bool,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    suggestions: PropTypes.array,
    tags: PropTypes.array,
  }

  static defaultProps = {
    allowDeleteFromEmptyInput: true,
    autocomplete: false,
    autofocus: false,
    clearable: false,
    delimeters: [13, 9],
    disabled: false,
    inline: true,
    minQueryLength: 2,
    mustMatch: false,
    placeholder: 'Search or filter options',
    readOnly: false,
    searchable: true,
    suggestions: [],
    tags: [],
  }

  constructor(props) {
    super(props)
    this.timeout = null
    this.state = {
      suggestions: this.props.suggestions,
      query: '',
      selectedIndex: -1,
      selectionMode: false,
      hasFocus: false,
    }
  }

  componentDidMount() {
    if (this.props.autofocus && !this.props.readOnly) {
      this.refs.input.focus()
    }
  }

  componentWillReceiveProps(props) {
    this.setState(() => ({
      suggestions: props.suggestions,
    }))
  }

  componentDidUpdate(nextProps) {
    if (nextProps.focus) {
      this.refs.input.focus()
    } else {
      this.refs.input.blur()
    }
  }

  _filteredSuggestions = (query, suggestions) => {
    return suggestions.filter((item) => {
      // filter suggestions that are already in the tags array
      const { tags } = this.props
      let keep = true
      tags.forEach((tag) => {
        if (tag.value === item.value) {
          keep = false
        }
      })
      return keep
    }).filter((item) => {
      // filter remaining suggestions by current query
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0
    })
  }

  _addTagByQuery = (query) => {
    let q = query
    if (this.state.selectionMode) {
      const suggestions = this._filteredSuggestions(query, this.props.suggestions)
      q = suggestions[this.state.selectedIndex]
    } else if (query !== '') {
      if (typeof q !== 'object') { q = { label: q } }
    }
    if (q !== '') { this._addTag(q) }
  }

  // Handlers
  _handleFocus = () => {
    if (this.props.onFocus) { this.props.onFocus(this.props.name) }
    this.setState(() => ({ hasFocus: true }))
  }

  _handleBlur = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if (this.props.onBlur) { this.props.onBlur(this.props.name) }
      this.setState(() => ({
        selectedIndex: -1,
        selectionMode: false,
        suggestions: [],
        query: '',
      }))
      if (this.refs.input) { this.refs.input.value = '' }
      // this.refs.input.value = ''
      // this.setState(() => ({ hasFocus: false }))
    }, 200)
  }

  _handleChange = (e) => {
    const query = e.target.value.trim()
    const suggestions = this._filteredSuggestions(query, this.props.suggestions)
    this.setState(() => ({
      query,
      suggestions,
    }))
  }

  _handleKeyDown = (e) => {
    const { query, suggestions } = this.state

    // Hide suggestions menu on escape
    if (e.keyCode === constants.KEY_CODES.ESC) {
      e.preventDefault()
      this.setState(() => ({
        selectedIndex: -1,
        selectionMode: false,
        suggestions: [],
      }))
    }

    // When one of the terminating keys is pressed, add current query to the tags.
    // If no text is typed in so far, ignore the action - so we don't end up with a terminating
    // character typed in.
    if (this.props.delimeters.indexOf(e.keyCode) !== -1) {
      if (e.keyCode !== constants.KEY_CODES.TAB) {
        e.preventDefault()
      }
      this._addTagByQuery(query)
    }

    // Up Arrow
    if (e.keyCode === constants.KEY_CODES.UP_ARROW) {
      e.preventDefault()
      const si = this.state.selectedIndex

      // On Last item go to the top
      if (si <= 0) {
        this.setState((prevState, props) => ({
          selectedIndex: props.suggestions.length - 1,
          selectionMode: true,
        }))
      } else {
        this.setState(() => ({
          selectedIndex: si - 1,
          selectionMode: true,
        }))
      }
    }

    // Down Arrow
    if (e.keyCode === constants.KEY_CODES.DOWN_ARROW) {
      e.preventDefault()
      this.setState(prevState => ({
        selectedIndex: (prevState.selectedIndex + 1) % suggestions.length,
        selectionMode: true,
      }))
    }
  }

  _handleClick = (tag) => {
    clearTimeout(this.timeout)
    this.setState(() => ({
      selectedIndex: -1,
      selectionMode: false,
    }))
    this._addTag(tag, true)
  }

  _addTag = (tag, viaClick = false) => {
    const input = this.refs.input

    let newTag = tag
    let hasMatch = false

    if (this.props.autocomplete && this.state.query !== '') {
      const possibleMatches = this._filteredSuggestions(tag.label, this.props.suggestions)

      if (this.props.autocomplete && possibleMatches.length) {
        hasMatch = true
        newTag = possibleMatches[0]
      }
    }

    // Call method to add
    if (
      !this.props.mustMatch
      || this.state.selectionMode
      || viaClick
      || (this.props.mustMatch && hasMatch)
    ) {
      this.props.handleSubmit(newTag.label)
    }

    // Reset the state
    this.setState(() => ({
      query: '',
      selectionMode: false,
      selectedIndex: -1,
    }))

    input.value = ''
    input.blur()

    // focus back on the input box
    clearTimeout(this.timeout)
    // this.setState(() => ({ hasFocus: true }))
  }

  _input = () => {
    // get the suggestions for the given query
    const query = this.state.query.trim()
    const selectedIndex = this.state.selectedIndex
    const suggestions = this.props.suggestions
    const { disabled, placeholder, id } = this.props

    return (
      <div className={styles.input} id={`${id}-input`}>
        <input
          aria-label={placeholder}
          autoComplete="off"
          disabled={disabled}
          onBlur={this._handleBlur}
          onChange={this._handleChange}
          onFocus={this._handleFocus}
          onKeyDown={this._handleKeyDown}
          placeholder={placeholder}
          ref="input"
          type="text"
        />
        <Suggestions
          handleClick={this._handleClick}
          minQueryLength={this.props.minQueryLength}
          query={query}
          selectedIndex={selectedIndex}
          show={this.props.focus}
          suggestions={this._filteredSuggestions(this.state.query, suggestions)}
        />
      </div>
    )
  }

  render() {
    const {
      tags,
      focus,
      disabled,
      className,
    } = this.props

    const classes = {
      [styles.isFocused]: focus,
      [styles.hasValue]: tags.length || this.state.query.length,
      [styles.disabled]: disabled,
    }

    return (
      <div className={classnames(styles.base, classes, className)}>
        <div className={styles.triangle} />
        <div className={styles.tags}>
          <div className={styles.selected}>
            {this.props.inline && this._input()}
          </div>
          {!this.props.inline && this._input()}
        </div>
        <span className={styles.bar} />
      </div>
    )
  }
}

export default SearchFilterInput



// WEBPACK FOOTER //
// ./src/components/SearchFilterInput/SearchFilterInput.js